import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { Subscription, forkJoin } from "rxjs";
import { finalize } from 'rxjs/operators';
import { EmitterService } from "src/app/EmitterService";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-other-notices",
  templateUrl: "./other-notices.component.html",
  styleUrls: ["./other-notices.component.scss"],
})
export class OtherNoticesComponent implements OnInit {
  Notices = [];
  subscription: Subscription;
  loading = true; // Changed from loadingData to loading
  urlSafe: SafeResourceUrl;
  find_category: any;

  selectedNotice: any;
  notice_cat_values: any[];
  filteredNotices: any[] = [];
  selectedCategory: string = "Search Notices";

  constructor(
    private emitterService: EmitterService,
    public sanitizer: DomSanitizer,
    private appService: AppService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadNotices();
  }

  loadNotices() {
    this.loading = true;
    
    forkJoin([this.appService.getNotices()]).pipe(
      finalize(() => this.loading = false)
    ).subscribe({
      next: (response: any) => {
        // Filter for Other Notices and active status
        this.Notices = (response[0].data || [])
          .filter(notice => 
            notice.ShowScroll === true && 
            notice.NoticeCategoryName === "Other Notice" &&
            (notice.IsActive === true || notice.Status === 'Active')
          );
        
        // Sort by ID (newest first)
        this.Notices.sort((a, b) => b.Id - a.Id);
        
        // Get unique categories (though it should just be "Other Notices")
        this.notice_cat_values = [...new Set(
          this.Notices.map(x => x.NoticeCategoryName)
        )];
        
        // Set filtered notices
        this.filteredNotices = [...this.Notices];
        
        // Update view
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading notices:', err);
        // Handle error (could show toast/message)
      }
    });
  }

  onSelectCategory(category: string): void {
    this.selectedCategory = category;
    this.filteredNotices = category === "All Notices"
      ? [...this.Notices]
      : this.Notices.filter(notice => notice.NoticeCategoryName === category);
  }

  onSearch(): void {
    this.filteredNotices = this.selectedCategory
      ? this.Notices.filter(notice => notice.NoticeCategoryName === this.selectedCategory)
      : [...this.Notices];
  }

  showNotice(event: Event, notice: any) {
    event.preventDefault();
    this.selectedNotice = notice;
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.selectedNotice.FileLink.includes("https://") 
        ? this.selectedNotice.FileLink 
        : `https://${this.selectedNotice.FileLink}`
    );
  }

  isImage(link: string): boolean {
    return /\.(jpe?g|png|gif)$/i.test(link);
  }

  TransformUrl(value: string) {
    this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(
      value.includes("https://") ? value : `https://${value}`
    );
    return this.urlSafe;
  }
}